/**
 * Created by andrey on 20.07.2020
 */

const AndroidSocial = function () {
    Social.call(this, connector.ANDROID);

    this.refreshThrottled = connector.utils.timeredThrottle(
        connector.utils.parseInterval("10 seconds"),
        () => this.refresh()
    );

    connector.timeouts.setInterval(() => {
        if (this.isConnected()) {
            this.refreshThrottled();
        }
    }, connector.utils.parseInterval("10 minutes"));
};

AndroidSocial.prototype = Object.create(Social.prototype);
AndroidSocial.prototype.constructor = AndroidSocial;

AndroidSocial.prototype._connect = function (callback) {
    this.refresh(() => {
        callback(connector.STATUS_CONNECTED);
    });
};

AndroidSocial.prototype.refresh = function (callback) {
    connector.platform.callNative("AndroidSocialPlugin.refresh", (code, authDetails) => {
        this.onAuthDetails(authDetails);

        callback && callback();
    });
};

AndroidSocial.prototype.isLoggedIn = function () {
    return Boolean(this.userId && this.accessToken);
};

AndroidSocial.prototype._getUserID = function () {
    return this.userId;
};

AndroidSocial.isAndroidUserId = function (id) {
    return id && id.indexOf("android_") === 0;
};

AndroidSocial.prototype.getAccessToken = function () {
    return this.accessToken;
};

AndroidSocial.prototype._login = function (callback) {
    connector.platform.callNative("AndroidSocialPlugin.login", (code, authDetails) => {
        this.onAuthDetails(authDetails);

        callback();
    });
};

AndroidSocial.prototype.onAuthDetails = function (authDetails) {
    if (authDetails.userId && authDetails.accessToken) {
        this.userId = `android_${authDetails.userId}`;
        this.accessToken = authDetails.accessToken;
    } else {
        this.userId = undefined;
        this.accessToken = undefined;
    }
};

AndroidSocial.prototype._aboutMe = function (callback) {
    connector.platform.callNative("AndroidSocialPlugin.aboutMe", (code, response) => {
        callback(code, response);
    });
};

AndroidSocial.isAvailable = function () {
    return connector.platform.oneOf(connector.ANDROID, connector.GPG);
};
